import React from 'react';
import Container from '../atoms/Container';
import Section from './Section';
import Heading from '../atoms/Heading';
import Image from '../atoms/Image';

const Footer = () => {
    const data = {
        logo: '/img/logo-white.svg',
    };
    return (
        <footer className='footer'>
            <Container className='footer-main-container'>
                <Section
                    config={{
                        items: [
                            {
                                col: 4,
                                colXs: 12,
                                type: 'section',
                                config: {
                                    items: [
                                        {
                                            type: 'logo',
                                            src: data.logo,
                                        },
                                        {
                                            type: 'paragraph',
                                            html: '<strong> Registered Office Address </strong>: 1203, Lodha Supremus, Senapati Bapat Marg, Lower Parel (W), Mumbai - 400013',
                                        },
                                        {
                                            type: 'link',
                                            config: {
                                                text: 'Email: info@saralscf.com',
                                                href: 'mailto:info@saralscf.com',
                                            },
                                        },
                                        {
                                            type: 'paragraph',
                                            html: '<strong>CIN: </strong>U74999MH2020PTC420187 </br><strong> Contact Person</strong>: Mr. Gaurav Bagrodia </br> <strong>Tel </strong>:  +91 22 62255544',
                                        },
                                        {
                                            type: 'heading',
                                            config: {
                                                className: 'mt-20',
                                                type: 'h5',
                                                text: 'Registered NBFC Partners',
                                            },
                                        },
                                        {
                                            type: 'link',
                                            config: {
                                                className: 'my-10 color-bcpl',
                                                text: 'Blacksoil Capital Pvt. Ltd.',
                                                href: 'http://blacksoil.co.in/',
                                                target: '_blank',
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                col: 1,
                            },
                            {
                                col: 4,
                                colXs: 12,
                                type: 'navigation',
                                config: {
                                    heading: 'Quick Links',
                                    items: [
                                        { text: 'Home', href: '/' },
                                        { text: 'About Us', href: '/about' },
                                        {
                                            text: 'Saral Pay Later',
                                            href: '/saral-solutions/saral-pay-later',
                                        },
                                        {
                                            text: 'Vendor Financing',
                                            href: '/saral-solutions/saral-vendor-finance',
                                        },
                                        {
                                            text: 'Corporate Working Capital',
                                            href: '/saral-solutions/corporate-working-capital',
                                        },
                                        { text: 'Contact Us', href: '/contact' },
                                    ],
                                },
                            },
                            {
                                col: 3,
                                colXs: 12,
                                type: 'navigation',
                                config: {
                                    heading: 'Other Links',
                                    items: [
                                        { text: 'Privacy Policy', href: '/privacy-policy' },
                                        {
                                            text: 'Terms & Conditions',
                                            href: '/terms-and-conditions',
                                        },
                                        {
                                            text: 'Regulatory & Compliance',
                                            href: '/regulatory-and-compliance',
                                        },
                                        {
                                            text: 'API Documentation',
                                            href: 'https://documenter.getpostman.com/view/9478456/TzRYe5Mf',
                                            target: '_blank',
                                        },
                                        {
                                            text: 'In the News',
                                            href: '/news',
                                        },
                                    ],
                                },
                            },
                        ],
                    }}
                />
            </Container>
            <div className='separator'></div>
            <div className='ecosystem-section'>
                <Heading
                    type='h3'
                    text='BlackSoil Ecosystem'
                    className='ecosystem-title'
                />
                <div className='ecosystem-grid'>
                    <div className='ecosystem-column'>
                        <div className='ecosystem-label'>NBFC</div>
                        <div className='ecosystem-box'>
                            <Image
                                src='/logos/blacksoilcapital.png'
                                alt='BlackSoil Capital'
                                className='ecosystem-logo'
                                width={120}
                                height={50}
                            />
                        </div>
                    </div>
                    <div className='ecosystem-column'>
                        <div className='ecosystem-label'>NBFC DIVISIONS</div>
                        <div className='ecosystem-box'>
                            <Image
                                src='/logos/saral.png'
                                alt='SaralSCF'
                                className='ecosystem-logo'
                                width={150}
                                height={50}
                            />
                        </div>
                        <div className='ecosystem-box'>
                            <Image
                                src='/logos/udhyamdebt.png'
                                alt='Udhyam Debt'
                                className='ecosystem-logo'
                                width={100}
                                height={50}
                            />
                        </div>
                    </div>
                    <div className='ecosystem-column'>
                        <div className='ecosystem-label'>PRIVATE CREDIT</div>
                        <div className='ecosystem-box'>
                            <Image
                                src='/logos/blacksoilamc.png'
                                alt='BlackSoil Asset Management'
                                className='ecosystem-logo'
                                width={120}
                                height={60}
                            />
                        </div>
                    </div>
                    <div className='ecosystem-column'>
                        <div className='ecosystem-label'>GLOBAL FUND</div>
                        <div className='ecosystem-box'>
                            <Image
                                src='/logos/blacksoilglobal.svg'
                                alt='BlackSoil Global'
                                className='ecosystem-logo'
                                width={230}
                                height={60}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
